var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenRing502(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 225,
    viewBox: "0 0 181 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 14",
    opacity: 0.6,
    filter: "url(#filter0_f_223_27612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.24 172.533C113.996 176.927 96.6796 174.716 82.0996 166.387C67.5197 158.058 56.8709 144.292 52.4958 128.119C48.1207 111.945 50.3778 94.6885 58.7705 80.145C67.1632 65.6015 81.004 54.9624 97.2481 50.5682L102.019 68.2038C90.4723 71.3272 80.6341 78.8896 74.6685 89.2272C68.7029 99.5649 67.0986 111.831 70.2084 123.327C73.3182 134.824 80.8875 144.608 91.251 150.529C101.615 156.449 113.923 158.021 125.47 154.897L130.24 172.533Z",
    fill: "#ABFF22"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_223_27612",
    x: 0.312988,
    y: 0.568176,
    width: 179.927,
    height: 224.175,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_223_27612"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenRing502);
export default __webpack_public_path__ + "static/media/green-ring50-2.1a3a8b7d1b2ad7f77877fac8fd9ce21e.svg";
export { ForwardRef as ReactComponent };